import React from 'react';
import { Pagination } from 'react-admin';

export const PaginationProps = (props:any) => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;